import { IDatePickerDates, IDateRangePickerOptions } from '../../models';

export function getSpecialRange(date: IDatePickerDates, options: IDateRangePickerOptions) {
    const beginIsoString = date.startDate.toISOString();
    const endIsoString = date.endDate.toISOString();
    let special = null;
    if (options.ranges) {
        for (const key of Object.keys(options.ranges)) {
            const begin = (options.ranges[key][0] as moment.Moment);
            const end = options.ranges[key][1] as moment.Moment;
            if (((begin && begin.toISOString() === beginIsoString) || options.ranges[key][0] === beginIsoString)
                && ((end && end.toISOString() === endIsoString) || options.ranges[key][1] === endIsoString)) {
                special = key;
                break;
            }
        }
    }
    return special;
}